import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-bubble-chart",
  templateUrl: "./bubble-chart.component.html",
  styleUrls: ["./bubble-chart.component.scss"]
})
export class BubbleChartComponent implements OnInit {
  public dataSource: any;
  public chart: any;

  @Input() chartData = { type: "bubble" };

  constructor() {
    this.dataSource = {
      chart: {
        theme: "fusion",
        caption: "Sales & Profit Analysis",
        subcaption: "For Last Quarter",
        xaxisminvalue: "0",
        yaxisminvalue: "0",
        yaxismaxvalue: "100",
        xaxisname: "Average Price",
        yaxisname: "Units Sold",
        numDivlines: "3",
        showValues: "1",
        plottooltext: "$name : Profit Contribution: $zvalue%",
        drawquadrant: "1",
        quadrantlabeltl: "",
        quadrantlabeltr: "",
        quadrantlabelbl: "",
        quadrantlabelbr: "",
        // quadrantxval: '100',
        // quadrantyval: '10000',
        quadrantlinealpha: "50",
        quadrantlinethickness: "2"
      },
      categories: [
        {
          category: [
            {
              label: "0",
              x: "0"
            },
            {
              label: "25",
              x: "25",
              showverticalline: "1"
            },
            {
              label: "50",
              x: "50",
              showverticalline: "1"
            },
            {
              label: "75",
              x: "75",
              showverticalline: "1"
            },
            {
              label: "100",
              x: "100",
              showverticalline: "1"
            }
          ]
        }
      ],
      dataset: [
        {
          data: [
            {
              x: "80",
              y: "15",
              z: "24",
              name: "Nike"
            }
          ]
        }
      ]
    };
  }
  ngOnInit() {}

  initialized($event) {
    this.chart = $event.chart; // Storing the chart instance
    this.updateChartValue(this.chartData);
  }

  updateChartValue(data) {
    //console.log(data);
    if (this.chart) {
      // this.dataSource['chart']['caption'] = data.caption;
      if (data.genConfig) {
        const config = Object.keys(data.genConfig);
        config.forEach((val, key) => {
          try {
            this.dataSource["chart"][val] = data.genConfig[val];
          } catch (error) {
            console.error("Error updating chart config:", error);
          }
        });
      }

      try {
        this.dataSource["dataset"] = data.config.dataSets;
        this.dataSource["categories"][0]["category"] = data.config.dataLabels;
      } catch (err) {
        console.error("Error updating dataset/categories:", err);
      }

      try {
        this.chart.setJSONData(this.dataSource);
      } catch (err) {
        console.error("Error setting chart data:", err);
      }
    }
  }
}
